module.exports = __webpack_public_path__ + "img/time7.0a482bc3.png";